import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';

import FlashMessage from '../../../molecules/FlashMessage/FlashMessage';
import useCart from '../../../../src/hooks/useCart';

/**
 * Composant pour afficher les alertes de stock et prix dans le Cart
 * Utilise le même style que FlashMessage
 * Types: 'danger' (stock épuisé), 'warning' (changement de prix)
 */
function CartAlert({
  errors = [],
  hasPriceChangeWarning = false,
  className = '',
}) {
  const { t } = useTranslation(['common']);
  const { putCart } = useCart();
  const didAutoValidateRef = useRef(false);

  useEffect(() => {
    if (hasPriceChangeWarning && !didAutoValidateRef.current) {
      didAutoValidateRef.current = true;
      // silently persist cart with server prices (no UI interaction)
      putCart(false).catch(() => {});
    }
  }, [hasPriceChangeWarning, putCart]);

  if ((!errors || errors.length === 0) && !hasPriceChangeWarning) {
    return null;
  }

  return (
    <div className={className}>
      {/* ERREURS - STOCK ÉPUISÉ */}
      {errors && errors.length > 0 && (
        <div className={hasPriceChangeWarning ? 'm-b-10' : ''}>
          <FlashMessage
            color="error"
            message={t('cart.alert.stock_unavailable')}
          />
        </div>
      )}

      {/* AVERTISSEMENT - CHANGEMENT DE PRIX (GÉNÉRIQUE) */}
      {hasPriceChangeWarning && (
        <FlashMessage
          color="alert"
          message={t('cart.alert.price_changed')}
        />
      )}
    </div>
  );
}

CartAlert.propTypes = {
  errors: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(['stage', 'option', 'accommodation']),
      message: PropTypes.string.isRequired,
      severity: PropTypes.string,
    }),
  ),
  hasPriceChangeWarning: PropTypes.bool,
  className: PropTypes.string,
};

CartAlert.defaultProps = {
  errors: [],
  hasPriceChangeWarning: false,
  className: '',
};

export default CartAlert;
